import React, { useEffect, useRef, useState } from "react";
import Colors from "../../../../stories/assets/Colors";
import Fonts from "../../../../stories/assets/Fonts";
import { Button } from "../../../../stories/Button/Button";
import {
  EquipmentIcon,
  ApparelIcon,
  AccessoriesIcon,
  AddIconBlue,
} from "../../../../constant/imagePath";
import { Row, Col, Container } from "react-bootstrap";
import { LinkButtonWithIcon } from "../../../../stories/LinkButtonWithIcon/LinkButtonWithIcon.jsx";
import classes from "./SetYourLesson.module.css";
import { TextArea } from "../../../../stories/TextArea/TextArea";
import { Checkbox } from "../../../../stories/Checkbox/Checkbox";
import { Tabs } from "../../../../stories/Tabs/Tabs";
import AddEquipmentModal from "../../../Modals/CoachFlow/OnBoarding/AddEquipment/AddEquipment";
import { isMobileViewHook } from "../../../../CustomHooks/isMobileViewHook";
import SetYourLessonMobile from "./SetYourLessonMobile";
import { useDispatch, useSelector } from "react-redux";
import { setPersonalData } from "../../../../store/Actions/authAction";
import PageProgressBar from "../../../../stories/PageProgressBar/PageProgressBar";

function SetYourLessonDesktop({ stepForwardAndBackward }) {
  const dispatch = useDispatch();
  const getDataFromRedux = useSelector(
    (state) => state?.onBoardingReducer?.setLesson
  );
  const [sessionPlan, setSessionPlan] = useState(
    getDataFromRedux?.sessionPlan ? getDataFromRedux?.sessionPlan : ""
  );
  const [tab, setTab] = useState({ label: "Provide", value: 4 });
  const [showEquipmentModal, setShowEquipmentModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalData, setModalData] = useState([]);
  // const currentTitle = useRef("");

  //  Provide states
  const [renderEquipments, setRenderEquipments] = useState(
    getDataFromRedux?.provide
      ? getDataFromRedux?.provide?.renderEquipments
      : [
          { label: "Grips", value: "Grips", isChecked: "" },
          { label: "Racquet string", value: "Racquet string", isChecked: "" },
          { label: "Tennis racquet", value: "Tennis racquet", isChecked: "" },
          { label: "Tennis Balls", value: "Tennis Balls", isChecked: "" },
        ]
  );
  const [renderApparels, setRenderApparels] = useState(
    getDataFromRedux?.provide
      ? getDataFromRedux?.provide?.renderApparels
      : [
          { label: "Tennis shoes", value: "Tennis shoes", isChecked: "" },
          { label: "Sweatbands", value: "Sweatbands", isChecked: "" },
          { label: "Practice skirt", value: "Practice skirt", isChecked: "" },
          { label: "Racquet bag", value: "Racquet bag", isChecked: "" },
          { label: "Practice shirts", value: "Practice shirts", isChecked: "" },
          { label: "Hat/Visor", value: "Hat/Visor", isChecked: "" },
        ]
  );
  const [renderAccessories, setRenderAccessories] = useState(
    getDataFromRedux?.provide
      ? getDataFromRedux?.provide?.renderAccessories
      : [
          { label: "Water", value: "Water", isChecked: "" },
          { label: "Sunglasses", value: "Sunglasses", isChecked: "" },
          {
            label: "Hair ties/Headband",
            value: "Hair ties/Headband",
            isChecked: "",
          },
          { label: "Athletic tape", value: "Athletic tape", isChecked: "" },
          { label: "Sunscreen", value: "Sunscreen", isChecked: "" },
        ]
  );
  //  Bring states
  const [renderEquipmentsForBring, setRenderEquipmentsForBring] = useState(
    getDataFromRedux?.bring
      ? getDataFromRedux?.bring?.renderEquipmentsForBring
      : [
          { label: "Grips", value: "Grips", isChecked: "" },
          { label: "Racquet string", value: "Racquet string", isChecked: "" },
          { label: "Tennis racquet", value: "Tennis racquet", isChecked: "" },
          { label: "Tennis Balls", value: "Tennis Balls", isChecked: "" },
        ]
  );
  const [renderApparelsForBring, setRenderApparelsForBring] = useState(
    getDataFromRedux?.bring
      ? getDataFromRedux?.bring?.renderApparelsForBring
      : [
          { label: "Tennis shoes", value: "Tennis shoes", isChecked: "" },
          { label: "Sweatbands", value: "Sweatbands", isChecked: "" },
          { label: "Practice skirt", value: "Practice skirt", isChecked: "" },
          { label: "Racquet bag", value: "Racquet bag", isChecked: "" },
          { label: "Practice shirts", value: "Practice shirts", isChecked: "" },
          { label: "Hat/Visor", value: "Hat/Visor", isChecked: "" },
        ]
  );
  const [renderAccessoriesForBring, setRenderAccessoriesForBring] = useState(
    getDataFromRedux?.bring
      ? getDataFromRedux?.bring?.renderAccessoriesForBring
      : [
          { label: "Water", value: "Water", isChecked: "" },
          { label: "Sunglasses", value: "Sunglasses", isChecked: "" },
          {
            label: "Hair ties/Headband",
            value: "Hair ties/Headband",
            isChecked: "",
          },
          { label: "Athletic tape", value: "Athletic tape", isChecked: "" },
          { label: "Sunscreen", value: "Sunscreen", isChecked: "" },
        ]
  );

  function onAdd() {
    if (tab?.label == "Provide") {
      if ("Equipment" === modalTitle) {
        const newArr = [...modalData];
        setRenderEquipments(newArr);
      }
      if ("Apparel" === modalTitle) {
        const newArr = [...modalData];
        setRenderApparels(newArr);
      }
      if ("Accessories" === modalTitle) {
        const newArr = [...modalData];
        setRenderAccessories(newArr);
      }
    } else {
      if ("Equipment" === modalTitle) {
        const newArr = [...modalData];
        setRenderEquipmentsForBring(newArr);
      }
      if ("Apparel" === modalTitle) {
        const newArr = [...modalData];
        setRenderApparelsForBring(newArr);
      }
      if ("Accessories" === modalTitle) {
        const newArr = [...modalData];
        setRenderAccessoriesForBring(newArr);
      }
    }
  }

  useEffect(() => {
    if (tab?.label == "Provide") {
      if ("Equipment" === modalTitle) {
        const newArr = [...renderEquipments];
        setModalData(newArr);
      }
      if ("Apparel" === modalTitle) {
        const newArr = [...renderApparels];
        setModalData(newArr);
      }
      if ("Accessories" === modalTitle) {
        const newArr = [...renderAccessories];
        setModalData(newArr);
      }
    } else {
      if ("Equipment" === modalTitle) {
        const newArr = [...renderEquipmentsForBring];
        setModalData(newArr);
      }
      if ("Apparel" === modalTitle) {
        const newArr = [...renderApparelsForBring];
        setModalData(newArr);
      }
      if ("Accessories" === modalTitle) {
        const newArr = [...renderAccessoriesForBring];
        setModalData(newArr);
      }
    }
  }, [showEquipmentModal]);

  function saveDataIntoRedux() {
    dispatch(
      setPersonalData("set-lesson", {
        provide: { renderEquipments, renderApparels, renderAccessories },
        bring: {
          renderEquipmentsForBring,
          renderApparelsForBring,
          renderAccessoriesForBring,
        },
        sessionPlan,
      })
    );
  }
  console.log({ getDataFromRedux });
  return (
    <div className={classes.setYourLesson}>
      <div className={classes.progressLine}>
        <PageProgressBar progress={"66.6%"} />
      </div>
      {/*  */}
      <Row className={`g-0 ${classes.row}`}>
        <Col md={12} className={`${[classes.saveAndFinish].join(" ")}`}>
          <LinkButtonWithIcon
            text={"Save and Finish Later"}
            customStyle={{
              color: Colors.neutralShadesOfNero,
              ...Fonts.b2,
              lineHeight: "20px",
            }}
            onClick={saveDataIntoRedux}
          />
        </Col>
        <Col md={12}>
          <Container fluid className={` ${classes.innerContainer}`}>
            <Col md={12}>
              <h3 style={{ ...Fonts.h3, color: Colors.neutralShadesOfNero }}>
                Set Your Lesson
              </h3>

              <p style={{ ...Fonts.p2, color: Colors.neutralShadesOfDimGray }}>
                1-on-1 lesson
              </p>
            </Col>

            <Col md={12} className={`${[classes.mt52].join(" ")}`}>
              <TextArea
                label={"Tell students about your session plan"}
                textAreaStyle={{ minHeight: "112px", maxHeight: "112px" }}
                placeholder="What will you cover in the lesson? What should students expect?"
                setter={setSessionPlan}
                state={sessionPlan}
              />
            </Col>
            {/* Tabs */}
            <Col md={12} className={`${[classes.mt80].join(" ")}`}>
              <Tabs
                tabsData={[
                  { label: "Provide", value: 4 },
                  { label: "What to bring", value: 0 },
                ]}
                state={tab}
                setState={setTab}
              />
            </Col>
            <Col md={12}>
              <h4 style={{ ...Fonts.h4, color: Colors.neutralShadesOfNero }}>
                {tab?.label === "Provide"
                  ? "What will you provide?"
                  : "What student should bring?"}
              </h4>
              <p style={{ ...Fonts.p1, color: Colors.neutralShadesOfDimGray }}>
                {tab?.label === "Provide"
                  ? "Select the things you can provide for your future students."
                  : "Select the things that the student should take to your lesson."}
              </p>
            </Col>

            {tab?.label == "Provide" ? (
              <Row className={["g-0", classes.mt52].join(" ")}>
                <Col md={12}>
                  <div
                    className={`${[classes.headingWithAddItem].join(" ")}`}
                    style={{
                      borderBottom: `1px solid ${Colors.neutralShadesOfWhisper}`,
                    }}
                  >
                    <div className={`${[classes.headingWithIcon].join(" ")}`}>
                      <img src={EquipmentIcon} />
                      <span
                        style={{
                          ...Fonts.h7,
                          lineHeight: "24px",
                          fontFamily: "inter-600",
                          color: Colors.neutralShadesOfNero,
                        }}
                      >
                        Equipment
                      </span>
                    </div>
                    {/* Right Side */}
                    <LinkButtonWithIcon
                      text={"Add item"}
                      leftIcon={AddIconBlue}
                      primary={true}
                      customStyle={{
                        ...Fonts.b2,
                        lineHeight: "20px",
                      }}
                      iconStyle={{
                        marginRight: "4px",
                        width: "16px",
                        height: "16px",
                      }}
                      onClick={() => {
                        setModalTitle("Equipment");
                        setShowEquipmentModal(true);
                      }}
                    />
                  </div>
                  <Col md={12}>
                    <Row>
                      {renderEquipments?.map((item, i) => {
                        return (
                          <Col md={6}>
                            <Checkbox
                              label={item?.label}
                              checked={item?.label == item?.isChecked}
                              onClick={(e) => {
                                const newArr = [...renderEquipments];

                                if (newArr[i].isChecked !== item?.label) {
                                  newArr[i].isChecked = item?.label;
                                } else {
                                  newArr[i].isChecked = "";
                                }
                                setRenderEquipments(newArr);
                              }}
                            />
                          </Col>
                        );
                      })}
                    </Row>
                  </Col>
                </Col>
                <Col md={12} className={classes.mt52}>
                  <div
                    className={`${[classes.headingWithAddItem].join(" ")}`}
                    style={{
                      borderBottom: `1px solid ${Colors.neutralShadesOfWhisper}`,
                    }}
                  >
                    <div className={`${[classes.headingWithIcon].join(" ")}`}>
                      <img src={ApparelIcon} />
                      <span
                        style={{
                          ...Fonts.h7,
                          lineHeight: "24px",
                          fontFamily: "inter-600",
                          color: Colors.neutralShadesOfNero,
                        }}
                      >
                        Apparel
                      </span>
                    </div>
                    {/* Right Side */}
                    <LinkButtonWithIcon
                      text={"Add item"}
                      leftIcon={AddIconBlue}
                      primary={true}
                      customStyle={{
                        ...Fonts.b2,
                        lineHeight: "20px",
                      }}
                      iconStyle={{
                        marginRight: "4px",
                        width: "16px",
                        height: "16px",
                      }}
                      onClick={() => {
                        setModalTitle("Apparel");
                        setShowEquipmentModal(true);
                      }}
                    />
                  </div>
                  <Col md={12}>
                    <Row>
                      {renderApparels?.map((item, i) => {
                        return (
                          <Col md={6}>
                            <Checkbox
                              label={item.label}
                              checked={item?.label == item?.isChecked}
                              onClick={(e) => {
                                const newArr = [...renderApparels];
                                if (newArr[i].isChecked !== item?.label) {
                                  newArr[i].isChecked = item?.label;
                                } else {
                                  newArr[i].isChecked = "";
                                }
                                setRenderApparels(newArr);
                              }}
                            />
                          </Col>
                        );
                      })}
                    </Row>
                  </Col>
                </Col>
                <Col md={12} className={classes.mt52}>
                  <div
                    className={`${[classes.headingWithAddItem].join(" ")}`}
                    style={{
                      borderBottom: `1px solid ${Colors.neutralShadesOfWhisper}`,
                    }}
                  >
                    <div className={`${[classes.headingWithIcon].join(" ")}`}>
                      <img src={AccessoriesIcon} />
                      <span
                        style={{
                          ...Fonts.h7,
                          lineHeight: "24px",
                          fontFamily: "inter-600",
                          color: Colors.neutralShadesOfNero,
                        }}
                      >
                        Accessories
                      </span>
                    </div>
                    {/* Right Side */}
                    <LinkButtonWithIcon
                      text={"Add item"}
                      leftIcon={AddIconBlue}
                      primary={true}
                      customStyle={{
                        ...Fonts.b2,
                        lineHeight: "20px",
                      }}
                      iconStyle={{
                        marginRight: "4px",
                        width: "16px",
                        height: "16px",
                      }}
                      onClick={() => {
                        setModalTitle("Accessories");
                        setShowEquipmentModal(true);
                      }}
                    />
                  </div>
                  <Col md={12}>
                    <Row>
                      {renderAccessories?.map((item, i) => {
                        return (
                          <Col md={6}>
                            <Checkbox
                              label={item.label}
                              checked={item?.label == item?.isChecked}
                              onClick={(e) => {
                                const newArr = [...renderAccessories];
                                if (newArr[i].isChecked !== item?.label) {
                                  newArr[i].isChecked = item?.label;
                                } else {
                                  newArr[i].isChecked = "";
                                }
                                setRenderAccessories(newArr);
                              }}
                            />
                          </Col>
                        );
                      })}
                    </Row>
                  </Col>
                </Col>
              </Row>
            ) : (
              <Row className={["g-0", classes.mt52].join(" ")}>
                <Col md={12}>
                  <div
                    className={`${[classes.headingWithAddItem].join(" ")}`}
                    style={{
                      borderBottom: `1px solid ${Colors.neutralShadesOfWhisper}`,
                    }}
                  >
                    <div className={`${[classes.headingWithIcon].join(" ")}`}>
                      <img src={EquipmentIcon} />
                      <span
                        style={{
                          ...Fonts.h7,
                          lineHeight: "24px",
                          fontFamily: "inter-600",
                          color: Colors.neutralShadesOfNero,
                        }}
                      >
                        Equipment
                      </span>
                    </div>
                    {/* Right Side */}
                    <LinkButtonWithIcon
                      text={"Add item"}
                      leftIcon={AddIconBlue}
                      primary={true}
                      customStyle={{
                        ...Fonts.b2,
                        lineHeight: "20px",
                      }}
                      iconStyle={{
                        marginRight: "4px",
                        width: "16px",
                        height: "16px",
                      }}
                      onClick={() => {
                        setModalTitle("Equipment");
                        setShowEquipmentModal(true);
                      }}
                    />
                  </div>
                  <Col md={12}>
                    <Row>
                      {renderEquipmentsForBring?.map((item, i) => {
                        return (
                          <Col md={6}>
                            <Checkbox
                              label={item?.label}
                              checked={item?.label == item?.isChecked}
                              onClick={(e) => {
                                const newArr = [...renderEquipments];

                                if (newArr[i].isChecked !== item?.label) {
                                  newArr[i].isChecked = item?.label;
                                } else {
                                  newArr[i].isChecked = "";
                                }
                                setRenderEquipmentsForBring(newArr);
                              }}
                            />
                          </Col>
                        );
                      })}
                    </Row>
                  </Col>
                </Col>
                <Col md={12} className={classes.mt52}>
                  <div
                    className={`${[classes.headingWithAddItem].join(" ")}`}
                    style={{
                      borderBottom: `1px solid ${Colors.neutralShadesOfWhisper}`,
                    }}
                  >
                    <div className={`${[classes.headingWithIcon].join(" ")}`}>
                      <img src={ApparelIcon} />
                      <span
                        style={{
                          ...Fonts.h7,
                          lineHeight: "24px",
                          fontFamily: "inter-600",
                          color: Colors.neutralShadesOfNero,
                        }}
                      >
                        Apparel
                      </span>
                    </div>
                    {/* Right Side */}
                    <LinkButtonWithIcon
                      text={"Add item"}
                      leftIcon={AddIconBlue}
                      primary={true}
                      customStyle={{
                        ...Fonts.b2,
                        lineHeight: "20px",
                      }}
                      iconStyle={{
                        marginRight: "4px",
                        width: "16px",
                        height: "16px",
                      }}
                      onClick={() => {
                        setModalTitle("Apparel");
                        setShowEquipmentModal(true);
                      }}
                    />
                  </div>
                  <Col md={12}>
                    <Row>
                      {renderApparelsForBring?.map((item, i) => {
                        return (
                          <Col md={6}>
                            <Checkbox
                              label={item.label}
                              checked={item?.label == item?.isChecked}
                              onClick={(e) => {
                                const newArr = [...renderApparels];
                                if (newArr[i].isChecked !== item?.label) {
                                  newArr[i].isChecked = item?.label;
                                } else {
                                  newArr[i].isChecked = "";
                                }
                                setRenderApparelsForBring(newArr);
                              }}
                            />
                          </Col>
                        );
                      })}
                    </Row>
                  </Col>
                </Col>
                <Col md={12} className={classes.mt52}>
                  <div
                    className={`${[classes.headingWithAddItem].join(" ")}`}
                    style={{
                      borderBottom: `1px solid ${Colors.neutralShadesOfWhisper}`,
                    }}
                  >
                    <div className={`${[classes.headingWithIcon].join(" ")}`}>
                      <img src={AccessoriesIcon} />
                      <span
                        style={{
                          ...Fonts.h7,
                          lineHeight: "24px",
                          fontFamily: "inter-600",
                          color: Colors.neutralShadesOfNero,
                        }}
                      >
                        Accessories
                      </span>
                    </div>
                    {/* Right Side */}
                    <LinkButtonWithIcon
                      text={"Add item"}
                      leftIcon={AddIconBlue}
                      primary={true}
                      customStyle={{
                        ...Fonts.b2,
                        lineHeight: "20px",
                      }}
                      iconStyle={{
                        marginRight: "4px",
                        width: "16px",
                        height: "16px",
                      }}
                      onClick={() => {
                        setModalTitle("Accessories");
                        setShowEquipmentModal(true);
                      }}
                    />
                  </div>
                  <Col md={12}>
                    <Row>
                      {renderAccessoriesForBring?.map((item, i) => {
                        return (
                          <Col md={6}>
                            <Checkbox
                              label={item.label}
                              checked={item?.label == item?.isChecked}
                              onClick={(e) => {
                                const newArr = [...renderAccessoriesForBring];
                                if (newArr[i].isChecked !== item?.label) {
                                  newArr[i].isChecked = item?.label;
                                } else {
                                  newArr[i].isChecked = "";
                                }
                                setRenderAccessoriesForBring(newArr);
                              }}
                            />
                          </Col>
                        );
                      })}
                    </Row>
                  </Col>
                </Col>
              </Row>
            )}
          </Container>
        </Col>
        {/* Btns Col */}

        <Col
          md={12}
          style={{
            borderTop: `1px solid ${Colors.neutralShadesOfGainsboro}`,
          }}
          className={classes.btnsCol}
        >
          <div className={classes.btnsBox}>
            <Button
              label={"Back"}
              size={"Large"}
              customStyle={{ width: "162px", height: "56px" }}
              onClick={() => stepForwardAndBackward(1, 2)}
            />
            <Button
              label={"Next"}
              primary={true}
              size={"Large"}
              customStyle={{ width: "162px", height: "56px" }}
              onClick={() => {
                saveDataIntoRedux();
                stepForwardAndBackward(2, 2);
              }}
            />
          </div>
        </Col>
      </Row>

      {/*  */}
      {/*  */}
      {/* Buttons Row */}
      {/* Add Equipment Modal */}
      <AddEquipmentModal
        show={showEquipmentModal}
        setShow={setShowEquipmentModal}
        title={modalTitle}
        state={modalData}
        setter={setModalData}
        onAdd={onAdd}
        options={["avbc", "cass"]}
      />
    </div>
  );
}

export default function SetYourLesson({ stepForwardAndBackward }) {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    isMobileViewHook(setIsMobile, 992);
  }, []);
  console.log(isMobile);
  return isMobile ? (
    <SetYourLessonMobile stepForwardAndBackward={stepForwardAndBackward} />
  ) : (
    <SetYourLessonDesktop stepForwardAndBackward={stepForwardAndBackward} />
  );
}
